import React from 'react';
import PaymentMethodListCard from "./PaymentMethodListCard";
import {ButtonBase, Grid, IconButton, Typography} from "@mui/material";
import {DeleteOutline} from "@mui/icons-material";
import {PaymentCardImg} from "../../views/booking-payment/style";
import {BankAccountStatus} from "../constants/securspace-constants";


const cardInfoContainerSx = {
  gap: '1em',
  alignItems: 'center',
} as const;

interface PartnerFundingSourceItemProps {
  bankName: string;
  bankAccountType: string;
  nickName: string;
  status: string | null;
  img: string;
  onMenuAction: (actionName: string) => void;
}

const PartnerFundingSourceItem = (props: PartnerFundingSourceItemProps) => {
  const {bankName, bankAccountType, nickName, status, img, onMenuAction} = props;

  const handleAction = (actionName: string): void => {
    onMenuAction(actionName);
  };

  return (
    <PaymentMethodListCard>
      <Grid item container alignContent={'center'} xs={12} sm sx={cardInfoContainerSx}>
        <PaymentCardImg src={img} alt="Payment Card" />
        <Typography variant={'h6'} color={'textPrimary'}>{bankName}</Typography>
      </Grid>
      <Grid item xs>
        <Typography variant={'h6'} color={'textPrimary'}>{bankAccountType}</Typography>
      </Grid>
      <Grid item xs>
        <Typography variant={'h6'} color={'textPrimary'}>{`Nick Name: ${nickName || 'n/a'}`}</Typography>
      </Grid>
      <Grid item xs>
        {
          status === BankAccountStatus.UNVERIFIED ?
            <ButtonBase onClick={() => onMenuAction('verify')}>
              <Typography variant={'h6'} color={'secondary'}>Click here to verify</Typography>
            </ButtonBase> :
            <Typography variant={'h6'} color={'textPrimary'}>{status === null ? 'Legacy' : status}</Typography>
        }
      </Grid>
      <Grid container item xs justifyContent={'flex-end'}>
        <IconButton onClick={() => handleAction('remove')} aria-label="Remove funding source">
          <DeleteOutline/>
        </IconButton>
      </Grid>
    </PaymentMethodListCard>
  );
};

export default PartnerFundingSourceItem;
